import { config1 } from "../config";

const host = config1.API_HOST;

export const loginApi = `${host}/vendor-login`;
export const sendOtp = `${host}/vendor-otp-login`;
export const vendorOtpVerification = `${host}/vendor-otp-verification`;
export const vendorTokenVerification = `${host}/vendor-token/verification`;
export const vendorPersonalInformation = `${host}/vendor/vendor-personal`;
export const vendorQualificationInformation = `${host}/vendor/vendor-educational`;
export const vendorBusinessInformation = `${host}/vendor/vendor-business`;
export const vendorServiceInformation = `${host}/vendor/vendor-services`;
export const getAllServices = `${host}/vendor/get-all-services`;
export const getVendorInformation = `${host}/vendor/vendor-details`;
export const getRegistrationOtp = `${host}/generate-vendor-otp`;
export const vendorRegistrationForm = `${host}/vendor-registration`;
export const vendorRegistrationFormServices = `${host}/vendor-registered-service/get-all-service`;

//nanny api's

export const generateNannyOtpApi = `${host}/nanny-otp-generate`;
export const verifyNannyOtpApi = `${host}/nanny-otp-verification`;
export const nannyStep1Api = `${host}/nanny-step1`;
export const nannyStep2Api = `${host}/nanny-step2`;
export const nannyStep3Api = `${host}/nanny-step3`;
export const nannyStep4Api = `${host}/nanny-step4`;
